module.exports = __webpack_public_path__ + "img/wallet_v2.00e3fdad.svg";